import Resources from './helpers/resources';

/**
 * COURSES
 */
export const getDefaultCourses = ({ productId }) =>
    (Resources.getDefaultCourses)
        .get()
        .withParams({ productId })
        .send();

export const getDefaultCourse = ({
    productId,
    courseId,
    version,
    switchToMasterCourseId,
    switchToMasterCourseVersion
}) =>
    (Resources.getDefaultCourse)
        .get({ courseId, version })
        .withParams({
            productId,
            ...(switchToMasterCourseId && { switchToMasterCourseId }),
            ...(switchToMasterCourseVersion && { switchToMasterCourseVersion })
        })
        .withBody()
        .send();

export const getDefaultCoursesForCountry = ({
    accessCode,
    productId
}) =>
    (Resources.getDefaultCourseForCountry)
        .get()
        .withParams({ accessCode, productId })
        .withBody()
        .send();

export const getCourses = ({
    accessStatus,
    countryCode,
    stateCode,
    productId
}) =>
    (Resources.getCourses)
        .post()
        .withBody({ accessStatus, countryCode, stateCode, productId })
        .send();

export const getCoursesForCountry = ({
    countryCode,
    productId
}) =>
    (Resources.getCoursesForCountry)
        .get()
        .withParams({ countryCode, productId })
        .withBody({ countryCode })
        .send();

export const saveDefaultCourses = ({
    accessStatus,
    countryCode,
    stateCode,
    productId,
    defaultCourses
}) =>
    (Resources.saveDefaultCourses)
        .post()
        .withBody({ accessStatus, countryCode, stateCode, productId, defaultCourses })
        .send();

export const saveDefaultCoursesForCountry = (
    accessCode,
    productId,
    defaultCourses
) =>
    (Resources.getDefaultCourseForCountry)
        .put()
        .withParams({ accessCode, productId })
        .withBody(defaultCourses)
        .raw()
        .send();

export const saveDefaultCourse = requestBody =>
    (Resources.saveDefaultCourse)
        .post()
        .withBody(requestBody)
        .send();

export const publishDefaultCourse = ({
    courseId,
    productId
}) =>
    (Resources.publishDefaultCourse)
        .put({ courseId })
        .withParams({ productId })
        .withBody()
        .raw()
        .send();

export const archiveSelectedCourse = (
    productId,
    courseId,
    courseVersion
) =>
    (Resources.archiveSelectedCourse)
        .delete({ courseId, courseVersion })
        .withParams({ productId })
        .withBody()
        .raw()
        .send();

/**
 * CURRICULUM/MASTER COURSE
 */
export const getMasterCourses = ({ accessStatus }) =>
    (Resources.getMasterCoursesByAccessStatus)
        .post()
        .withBody({ accessStatus })
        .send();

export const getMasterCoursesCountries = () =>
    (Resources.getMasterCoursesCountries
        .get()
        .send());

export const getMasterCoursesByCountry = ({ countryCode }) =>
    (Resources.getMasterCoursesByCountry)
        .get()
        .withParams({ countryCode })
        .send();

export const getMasterCourse = (
    masterCourseId,
    version
) =>
    (Resources.getMasterCourse)
        .get({ masterCourseId, version })
        .send();

/**
 * SUBJECTS
 */
export const getSubjects = () =>
    (Resources.getSubjects
        .get()
        .send());

/**
 * AUTH
 */
export const checkUserIsAuthorised = () =>
    (Resources.checkUserIsAuthorised)
        .get()
        .send();



// WEBPACK FOOTER //
// ./app/api.js